<template>
  <div id="content-container" v-if="item">
    <div class="panel">
      <el-page-header @back="$router.go(-1)" content="分类详情">
      </el-page-header>
      <el-descriptions title="" :column="1">
        <el-descriptions-item label="名称">{{
          item.name
        }}</el-descriptions-item>
        <el-descriptions-item label="是否固定资产">{{
          item.asset_type == 2 ? '是' : '否'
        }}</el-descriptions-item>
        <el-descriptions-item
          label="寿命预警条件"
          v-if="item.category == 2 && item.code_type == 1"
          >最近一次维修后：寿命值达到<span class="text-danger">{{
            item.warning_current_day
          }}</span
          >天
          <span class="text-danger ml-5 mr-5">{{
            item.warning_condition_type == 2 ? '且' : '或'
          }}</span>
          工作时长达到
          <span class="text-danger">{{ item.warning_current_hour }}</span
          >小时</el-descriptions-item
        >
        <el-descriptions-item label="成品属性">
          <el-breadcrumb separator="|">
            <el-breadcrumb-item>{{
              item.code_type == 1 ? '编号' : '编码'
            }}</el-breadcrumb-item>
            <el-breadcrumb-item
              v-for="(item, index) in item.custom_params"
              :key="item.label + index"
              >{{ item.label }}
              <el-tag size="mini" v-if="item.model_alias"
                >规</el-tag
              ></el-breadcrumb-item
            >
            <el-breadcrumb-item>状态</el-breadcrumb-item>
            <el-breadcrumb-item>备注</el-breadcrumb-item>
          </el-breadcrumb>
        </el-descriptions-item>
        <el-descriptions-item label="成品配件" v-if="item.code_type == 1">
          <el-breadcrumb separator="|">
            <el-breadcrumb-item
              v-for="item in item.item_template_names"
              :key="item"
              >{{ item }}</el-breadcrumb-item
            >
          </el-breadcrumb>
        </el-descriptions-item>
      </el-descriptions>

      <el-button
        size="mini"
        type="primary"
        plain
        v-permission="
          item.category == 1
            ? Auth.productTemplateEdit
            : Auth.instrumentTemplateEdit
        "
        @click.native="editItem"
        >编辑</el-button
      >
      <el-button
        size="mini"
        type="primary"
        plain
        v-if="item.code_type == 1"
        v-permission="
          item.category == 1
            ? Auth.productTemplateComponent
            : Auth.instrumentTemplateComponent
        "
        @click.native="addTemplateComponent"
        >添加组件</el-button
      >
    </div>

    <div class="panel">
      <el-tabs v-model="activeTab">
        <el-tab-pane
          :label="item.code_type == 2 ? '库存对象' : '成品列表'"
          name="tab1"
        >
          <template v-if="item.id">
            <StockProduct
              v-if="item.code_type == 2"
              :template="item"
            ></StockProduct>
            <ProductIndex
              v-else
              :category="item.category"
              :productTemplateId="item.id"
            ></ProductIndex>
          </template>
        </el-tab-pane>
        <el-tab-pane
          v-for="(cmp, index) in tempComponets"
          :key="cmp.id"
          :label="`${cmp.name}拆检记录`"
          :name="`tab${index + 2}`"
        >
          <DisassembRecord
            :template-id="item.id"
            :cmp="cmp"
            :category="item.category"
            v-if="item.id"
          ></DisassembRecord>
        </el-tab-pane>
        <el-tab-pane
          label="预警条件设置"
          name="tabwarning"
          v-if="
            item.category == 1 && item.id == 1 && hasAuth('productTemplateEdit')
          "
        >
          <WarningRule
            :productTemplateId="item.id"
            title="钻具规格"
          ></WarningRule>
        </el-tab-pane>
      </el-tabs>
    </div>

    <ItemFormer
      :model="model"
      :show.sync="formerVisible"
      @updated="updatedCallback"
    ></ItemFormer>

    <ComponentFormer
      :model="model"
      :show.sync="componentFormerVisible"
      @edit="componentCreatedCallback"
    ></ComponentFormer>
  </div>
</template>

<script>
import {
  productTemplateDetail,
  productComponentTemplateList,
} from '@/service/getData'
import ProductIndex from '../products/index'
import ItemFormer from './former'
import ComponentFormer from './componentFormer'
import DisassembRecord from './disassemb_record.vue'
import WarningRule from '../warning_rules/index'
import StockProduct from './StockProduct.vue'

export default {
  components: {
    ProductIndex,
    ItemFormer,
    ComponentFormer,
    DisassembRecord,
    WarningRule,
    StockProduct,
  },
  data() {
    return {
      item: null,
      activeTab: 'tab1',
      model: {},
      formerVisible: false,
      componentFormerVisible: false,
      tempComponets: [],
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await productTemplateDetail(this.$route.params.id)
      if (res.code == 0) {
        this.item = res.data
        this.getProductComponentList()
      }
    },
    editItem() {
      this.model = this.clone(this.item)
      this.formerVisible = true
    },
    updatedCallback(data) {
      this.item = data
    },

    async getProductComponentList() {
      let res = await productComponentTemplateList({
        product_template_id: this.item.id,
      })
      if (res.code == 0) {
        this.tempComponets = res.data.list
      }
    },

    addTemplateComponent() {
      this.model = {
        product_template_id: this.item.id,
        item_template_ids: [],
        export_fields: {},
      }
      this.componentFormerVisible = true
    },

    componentCreatedCallback() {
      this.getProductComponentList()
    },
  },
}
</script>

<style>
.el-timeline-item {
  padding-bottom: 10px;
}
</style>